export default __webpack_public_path__ + "static/media/ks1_fun_day_tile.4937a365.jpg";